// src/data/dispatchData.js
import axios from "axios";

// Base URL for backend API calls
// const API_BASE = "http://192.168.1.248:3107";

// Helper: Convert a date string from "YYYY-MM-DD" to "DD/MM/YYYY" format.
const normalizeDate = (value) => {
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value.split("T")[0].split("-").reverse().join("/");
    }
    return value;
};

/**
 * Fetch and transform dispatch challan data by ChallanAutoID
 * @param {string|number} challanId
 * @returns {Promise<Object>} - Normalized object with master + items
 */
const PurDispatchData = async (challanId, connectionString, companyId) => {
    try {
        const url = `${connectionString}/api/get-purdispatch-data/${challanId}`;
        const res = await axios.get(url);
        console.log('>>>', res.data);
        const { master, items = [] } = res.data;

        let imageBase64 = '';
        try {
            console.log(`HARSH: ${connectionString}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
            const iconRes = await axios.get(`${connectionString}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
            if (iconRes?.data?.success && iconRes.data.imageBase64) {
                console.log('Company logo fetched successfully');
                imageBase64 = iconRes.data.imageBase64;
            } else {
                console.warn('No logo returned from API');
            }
        } catch (iconErr) {
            console.warn('Failed to fetch company icon:', iconErr?.response?.data || iconErr.message);
        }

        // Remap item details
        const transformedItems = items.map((d) => {
            const rateNum = parseFloat(d.Rate) || 0;
            const amount = parseFloat(d.ItemTotal) || 0;
            // Calculate CGST % based on tax amount vs rate
            const cgst = parseFloat(d.CGST) || 0;
            // SGST/IGST columns not provided by API, default to zero
            const sgst = parseFloat(d.SGST) || 0;
            const igst = parseFloat(d.IGST) || 0;

            const tax = igst > 0 ? igst : (cgst + sgst);
            // If color or size info not mapped, fallback to "Unknown"
            const color = d.itemColorName || "Unknown";
            const size = d.itemSizeName || "Unknown";

            return {
                hsnCode: d.HSN || "",            // Using itemCode from productmaster
                description: `${d.itemCode || ""} - ${d.description || ""}`,
                qty: d.Qty || 0,
                unit: d.UnitValue,
                rate: rateNum,
                discount: parseFloat(d.Disc) || 0,
                cgst,
                sgst,
                igst,
                tax,
                amount: amount
            };
        });
        console.log("master data:", master);

        // Remap master (header) info
        return {
            companyName: master.clientDetails?.clientname || "",
            address: master.clientDetails?.address || "",
            phone: master.clientDetails?.mobileNo || "",
            gstNo: master.clientDetails?.gstno || "", // You didn't provide GST number in the response; set empty or add if available
            invoiceNo: master.ChallanNumber || "",
            referrenceNo: master.PartyPONO || "",
            date: normalizeDate(master.ChallanDate),
            transport: "SELF", // Not provided, default to SELF
            challanNo: master.ChallanNumber || "",
            poNo: master.PartyPONO || "",
            state: master.clientDetails?.state || "",
            stateCode: master.clientDetails?.stateCode || "", // Not provided in API
            LrNo: master.ChallanNumber || "",
            vehNo: "", // Not provided in API
            LrDate: normalizeDate(master.DeliveryDate),
            shipToGstNumber: "", // Not provided
            shipToState: master.clientDetails?.state || "",
            items: transformedItems,
            toEmail: master.clientDetails?.emailId || "",
            totalAmount: parseFloat(master.BillAmt) || 0,
            mobileNo: master.clientDetails?.mobileNo || "",
            // basicAmount: master.BasicAmt || 5,
            BasicAmt: Number(master.BasicAmt),
            CGSTAmt: Number(master.CGSTAmt),
            SGSTAmt: Number(master.SGSTAmt),
            IGSTAmt: Number(master.IGSTAmt),
            RoundOff: Number(master.RoundOff),
            BillAmt: Number(master.BillAmt),
            clientState: master.clientState || '',
            imageBase64,
            // clientStateCode: master.clientStateCode || '',
        };
    } catch (err) {
        console.error(`Error loading dispatchData for id=${challanId}`, err);
        throw err;
    }
};

export default PurDispatchData;